import request from '@/utils/request'

//   获取问卷单个主题详情
export function getPollTopicModel(params) {
    return request({
        url: '/api/PollTopic/Get',
        method: 'get',
        params
    })
}

//   获取问卷主题信息
export function getPollTopicList(params) {
    return request({
        url: '/api/PollTopic/LoadQT',
        method: 'get',
        params
    })
}

export function getPollGetAnswerList(params) {
    return request({
        url: '/api/PollData/GetAnswerList',
        method: 'get',
        params
    })
}

//加载题目
export function getPollQuestionList(params) {
    return request({
        url: '/api/PollQuestion/GetList',
        method: 'get',
        params
    })
}

//   查询问卷题目选项
export function getPollChoiceModel(params) {
    return request({
        url: '/api/PollQuestion/GetChoices',
        method: 'get',
        params
    })
}


//   获取前台答题信息
export function GetQuestionInfoList(params) {
    return request({
        url: '/api/PollQuestion/GetQuestionInfo',
        method: 'get',
        params
    })
}

export function AddPollDataMore(id, studentid, data) {
    return request({
        url: '/api/PollData/AddMore?topicId=' + id + '&&userId=' + studentid,
        method: 'post',
        data
    })
}

//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}

//获取前台答题统计
export function getQuestionTJ(params) {
    return request({
        url: '/api/PollQuestion/GetQuestionTJ',
        method: 'get',
        params
    })
}

//   获取问卷主题详情
export function getPollGetTongJi(params) {
    return request({
        url: '/api/PollTopic/GetTongJi',
        method: 'get',
        params
    })
}

// 查询结果  
export function PollDataGetPollRecord(params) {
    return request({
        url: '/api/PollData/GetPollRecord',
        method: 'get',
        params
    })
}

// 查询资源 
export function TrainFileLoad(params) {
    return request({
        url: '/api/TrainFile/Load',
        method: 'get',
        params
    })
}